// extracted by mini-css-extract-plugin
export var loadingSpinner = "_47-1";
export var standaloneTable = "_47-0";